import { UserRole } from './modules/auth/models/user.model';
import { NavItem } from './modules/main/services/nav.service';

export const navigation: NavItem[] = [
  {
    title: 'Settings',
    route: '/admin/profile',
    icon: 'settings',
  },
  {
    title: 'Your subscription',
    route: '/admin/subscription',
    icon: 'lock',
  },
  {
    title: 'Support',
    route: '/admin/faq',
    icon: 'info',
    hidden: true,
  },
  {
    title: 'Contact',
    route: '/admin/contact',
    icon: 'mail',
  },
  {
    title: 'User Panel',
    route: '/admin/user-panel',
    icon: 'users',
    roles: [UserRole.WdlAdmin, UserRole.WdlModerator],
  },
];
